import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding-bottom: 40px;

  .dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px;
    flex-wrap: wrap;
    gap: 20px;
  }

  h1 {
    font-size: 24px;
    margin: 0;
    color: #1a1a1a;
  }

  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 30px 0 15px 0;
    display: flex;
    align-items: center;
    gap: 10px;

    &::after {
      content: "";
      flex: 1;
      height: 1px;
      background: #f0f0f0;
    }
  }

  /* Tags/Cards informativos principais */
  .main-tags {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    margin-bottom: 30px;
    width: 100%;
  }

  @media (max-width: 900px) {
    .main-tags {
      grid-template-columns: 1fr;
    }
  }

  .tag-item {
    padding: 20px 25px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    background: #fff;
    color: #333;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;

    .tag-header {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }

    .value {
      font-size: 26px;
      color: #1a1a1a;
      font-weight: 800;
      margin-top: 5px;
    }

    &.highlight {
      border-left: 4px solid #008037;
      .value {
        color: #008037;
      }
    }

    &.warning {
      border-left: 4px solid #f2760a;
      .value {
        color: #f2760a;
      }
    }
  }

  /* Grid de Status dos Leads */
  .status-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 15px;
    margin-bottom: 30px;
  }

  .status-tag {
    background: #fff;
    padding: 15px 20px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s;
    cursor: pointer;

    &:hover {
      border-color: var(--color);
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    }

    .label {
      color: #666;
      font-size: 14px;
      font-weight: 500;
    }

    .count {
      font-size: 22px;
      font-weight: 800;
      color: var(--color);
    }
  }

  .main-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 30px;
  }

  .insight-card {
    background: #fff;
    padding: 25px;
    border-radius: 20px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 35px rgba(0, 0, 0, 0.06);
    }

    .icon-wrapper {
      width: 45px;
      height: 45px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      &.green {
        background: #e6f4ea;
        color: #008037;
      }
      &.orange {
        background: #fff4e6;
        color: #f2760a;
      }
      &.blue {
        background: #e6f7ff;
        color: #1890ff;
      }
    }

    label {
      font-size: 13px;
      color: #888;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .value-row {
      display: flex;
      align-items: baseline;
      gap: 10px;
      margin-top: 8px;

      h3 {
        font-size: 28px;
        font-weight: 800;
        margin: 0;
        color: #1a1a1a;
      }

      span.unit {
        font-size: 14px;
        color: #999;
        font-weight: 600;
      }
    }

    .footer-info {
      margin-top: 15px;
      padding-top: 15px;
      border-top: 1px solid #f9f9f9;
      font-size: 12px;
      color: #666;
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }

  .conversion-insight {
    grid-column: span 1;
    background: linear-gradient(135deg, #ffffff 0%, #f8faf9 100%);

    .progress-container {
      margin-top: 20px;
      .ant-progress-inner {
        background-color: #f0f0f0;
      }
    }
  }
`;
